import { Navigate } from 'react-router-dom';
import { getViewerToken } from './liveClient';

/**
 * Universal viewer entry point — smngp.com/live
 * Redirects authenticated viewers straight to their dashboard,
 * everyone else lands on the login page.
 */
export default function LiveEntryPage() {
  if (getViewerToken()) return <Navigate to="/live/dashboard" replace />;
  return <Navigate to="/live/login" replace />;
}
